import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';

import styles from './SkeletonLoader.module.scss';

function SkeletonLoader({ width, height, className }) {
  return (
    <div className={cn([styles.loading_container, className])} style={{ width, height }} />
  );
}

SkeletonLoader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

SkeletonLoader.defaultProps = {
  width: '100%',
  height: '100%',
  className: '',
};

export default SkeletonLoader;
